export default __webpack_public_path__ + "static/13-1--54586a3dc6a47bbed148949fdaeb38b1.png";